module.exports = __webpack_public_path__ + "img/dcCharge_offline.9238d90a.png";